import { useMemo } from "react";
import QRCode from "react-qr-code";
import { getBookingQrValue } from "./bookingQr";

export default function BookingQrCode({
  booking,
  customerId,
  appConfigName,
  size = 256,
  style,
}) {
  const qrValue = useMemo(
    () => getBookingQrValue({ booking, customerId, appConfigName }),
    [booking, customerId, appConfigName]
  );

  if (!booking?.id && !booking?.booking_id) {
    return null;
  }

  return (
    <div style={{ background: "#FFFFFF", padding: 20 }}>
      <QRCode
        value={qrValue}
        size={size}
        bgColor="#FFFFFF"
        fgColor="#000000"
        level="L"
        title="Booking QR Code"
        style={{ height: "auto", maxWidth: "100%", width: "100%", ...style }}
        viewBox="0 0 256 256"
      />
    </div>
  );
}
